// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c05d0d97","498":"a1d79e0c","703":"f07d9216","787":"1d345870"}[chunkId] + ".chunk.js";
};